// extracted by mini-css-extract-plugin
export default {"container":"gy1tIz","separator":"k2WgW_ mz-link"};